import React from 'react'
import Container from '@mui/material/Container'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import noInvoiceImage from '@/images/no_invoice.png'

const EmptyBox: React.FC = () => {
  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} data-testid="empty-box">
      <CardMedia
          component="img"
          image={noInvoiceImage}
          sx={{ height: '250px', width: '250px', aspectRatio: '1 / 1' }}
        />
      <Typography variant='h5' color='text.primary'>Não há resultados para exibir</Typography>
    </Container>
  )
}

export default EmptyBox
